import React, { ReactElement } from 'react';
import { Grid } from '@mui/material';
import Aums from '../../../../components/aum/aums';
import { investmgrContext, setUpdateHook } from '../../../../hooks/datatabs';
import NextReviewParameters from '../../../../components/nextreviews/nextreviewparameters';
import AuditedEntitiesService from '../../../../services/auditedentities';

function Parameters(): ReactElement {
  const entity = investmgrContext();
  const update = setUpdateHook();
  const entityService = entity ? new AuditedEntitiesService(entity.type || 'investMgr', entity._id) : undefined;

  return (
    <>
      { entity && entityService &&
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Aums name={entity.name} aumService={entityService} aum={entity.aum} update={() => update(true)} entity />
          </Grid>
          <Grid item xs={12}>
            <NextReviewParameters nextReviews={entity.nextReviews} service={entityService} update={() => update(true)} />
          </Grid>
        </Grid>
      }
    </>
  );
}

export default Parameters;
